import React from "react";
import { styled } from "@mui/material";
import { Box } from "@origin-digital/ods-core";

interface ICountBadgeProps {
  count: number;
}

interface IStyledBadgeProps {
  extend: boolean;
}

const StyledBadge = styled(Box)((props: IStyledBadgeProps) => ({
  backgroundColor: "#EC0000",
  color: "white",
  display: "flex",
  textAlign: "center",
  fontSize: "14px",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "20px",
  height: "20px",
  borderRadius: props.extend ? "12px" : "50%",
  fontWeight: "normal",
}));

const CountBadge = (props: ICountBadgeProps) => {
  const { count } = props;
  return (
    <StyledBadge extend={count > 9} marginLeft="xxsmall" paddingX="xxsmall">
      {count}
    </StyledBadge>
  );
};

export default CountBadge;
